function renameFunction(projectnumber, renameinputbox) {
     
  var renameBox = document.getElementById(renameinputbox);
  var textValue = renameBox.value; 
  renameBox.removeAttribute("readonly");
  renameBox.value = '';    
  renameBox.focus();
  renameBox.value = textValue;
}

function saveNewName(name, id, old_name) {
  $.ajax({
    type: "GET",
    url: "/rename/project/",
    data: {
      projectID: id,
      projectName: name
    },
    success: function (data) {
      console.log(data);
      const obj = JSON.parse(data);
      if ( obj.status == 'error' ) {
       
        $("#renameTextBox" + id)
          .val(old_name)
          .focus()
          .removeAttr("readonly");
         
      }
      if ( old_name !== name ) {
        $("#favs-panel-msg").text(obj.message).removeClass().addClass(obj.status).stop().fadeIn(200);
        setTimeout(function(){$("#favs-panel-msg").stop().fadeOut(200);}, 3000);
      }
    },
    error: function (data) {
      console.log(data);
    }
  });
}

/*
var element = document.querySelectorAll('[id^="renameTextBox"]');
[].forEach.call(element, function (renameBox) {
  renameBox.addEventListener("blur", function () {
    renameBox.setAttribute("readonly", true);
    saveNewName(renameBox.value, renameBox.getAttribute("projectID"));
  });
});
*/

function copyLinkToClipboard(projectID, loopcount) {
  var linkToProject = account_data.scheme + '://' + account_data.host + '/account/projects-details/' + projectID;
  var input         = document.body.appendChild(document.createElement("input"));
  input.value       = linkToProject;
  var x             = window.scrollX;
  var y             = window.scrollY;
  input.focus();
  window.scrollTo(x, y);
  input.select();
  document.execCommand("copy");
  input.parentNode.removeChild(input);

  /* Alert the copied text */
  var popup = document.getElementById("myPopup" + loopcount);
  popup.classList.toggle("show");

  setTimeout(function () {
    popup.classList.toggle("show");
  }, 4000);
}

jQuery(document).ready(function ($) {

  $("body").on("blur", ".rename-project-input", function() {
    var renameBox = $(this);
    saveNewName(renameBox.val(), renameBox.attr("projectid"), renameBox.data("old-name"));
    console.log('renaming.... ');
    renameBox.attr("readonly", true);
  });

  /* PROJECTS */
  $(".delete-project").on("click", function (e) {
    e.preventDefault();
    var form_id      = $(this).data("form-id");
    var project_name = $(this).data("project-name");
    var project_id   = $(this).data("project-id");
    var folder_name  = project_id;

    open_confirmation_modal("Are you sure you want to delete project <strong>" 
      + folder_name 
      + "</strong>?", "", 
      function () {
        // do something if confirmed
        deleteProject(form_id, project_id, project_name);
    });
  });

  function deleteProject(form_id, project_id, project_name) {
    var formDelete   = $("#" + form_id);
    var token        = formDelete.find('[name="csrfmiddlewaretoken"]').val();

    $.ajax({
      type: "POST",
      url: "/account/projects/?project=" + project_name,
      data: {
        project_id: project_id,
        delete_project: project_name,
        project_name_to_delete: project_name,
        csrfmiddlewaretoken: token,
        ajax: true
      },
      success: function (data) {
        console.log(data);
        const obj = JSON.parse(data);
        $("#cellProject" + obj.project_id).fadeOut("1000", function () {
          $(this).remove();
        });
      }
    });
  }

  /* PROPERTIES */
  function removeProperty(project_id, property_id, item_id) {
    $.ajax({
      type: "GET",
      url: "/remove/from/project/",
      data: {
        project: project_id,
        location: property_id
      },
      success: function (data) {
        if ( $('#cellProperty' + item_id).hasClass('list-item') ) {
          console.log('callbackRemovePropertyFromList '+data);
          callbackRemovePropertyFromList(item_id, data);
        } else {
          callbackRemovePropertyFromProject(item_id, data);
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(thrownError);
      }
    });
  }

  // remove property from grid callback
  function callbackRemovePropertyFromProject(item_id, data) {
    console.log(data);
    $("#cellProperty" + item_id).fadeOut("1000", function () {
      $(this).remove();
    });
  }

  // remove property from list callback
  function callbackRemovePropertyFromList(item_id, data) {
    console.log(data);
    $("#cellProperty" + item_id).find('.action-add-remove')
        .removeClass('remove-property')
        .addClass('add_to_project');
    $("#favsButton")
      .removeClass()
      .addClass("trigger_add_to_project")
      .data("pid", item_id);
  }
  
  // remove propery
  $("body").on("click", ".remove-property", function(e) {
    e.preventDefault();
    var property_id   = $(this).data("property-id");
    var property_name = $(this).data("property-name");
    var project_id    = $(this).data("project-id");
    var project_name  = $(this).data("project-name");
    
    if ( $(this).parent().hasClass('list-item') ) {
      console.log('parent has class list-item');
      removeProperty(project_id, property_id, project_id);
    } else {
      open_confirmation_modal("Are you sure you want to remove " 
        + property_name + " from <strong>" 
        + project_name + "</strong> folder?", "", 
        function () {
          removeProperty(project_id, property_id, property_id);
      });
    }
  });

  // confirmation modal
  function open_confirmation_modal(title, message, callback) {
    // modal template
    var modal = '<div class="reveal small" id="confirmation">' 
      + '<h2 class="align-center text-uppercase">' 
      + title 
      + "</h2>" 
      + '<p class="lead">' 
      + message 
      + "</p>" 
      + '<div class="button-group expanded"><button class="button confirm yes">Delete</button>' 
      + '<button class="button cancel float-right" data-close>Cancel</button>' 
      + "</div></div>";
    // appending new reveal modal to the page
    $("body").append(modal);
    // registerging this modal DOM as Foundation reveal
    var confirmation = new Foundation.Reveal($("#confirmation"));
    // open
    confirmation.open();
    // listening for yes click
    $("#confirmation").find(".yes").on("click", function () {
      // close and remove from DOM to avoid multiple binding
      confirmation.close();
      $("#confirmation").remove();
      // calling the function to process
      callback.call();
    });
    $(document).on("closed.zf.reveal", "#confirmation", function () {
      // remove from DOM when closed
      $("#confirmation").remove();
    });
  }
});